// extracted by mini-css-extract-plugin
export default {"searchBar":"styles_searchBar__YzGj5","form":"styles_form__+wb4a","searchIcon":"styles_searchIcon__k3Q4z","input":"styles_input__yH6Kq"};